window.addEventListener("DOMContentLoaded", function () {
	/* video play */
	let videoButton = document.querySelector("#custom_play_button");
	let customVideo = document.querySelector("#custom-video video");
	if (videoButton) {
		videoButton.addEventListener("click", function () {
			console.log("video-click");
			if (!customVideo) return;
			if (customVideo.paused == true) {
				// Play the video
				customVideo.play();

				// Update the button text to 'Pause'
				document.querySelector("#custom_play_button .play_button_icon").style.display = "none";
				document.querySelector("#custom_play_button .pause_button_icon").style.display = "flex";
			} else {
				// Pause the video
				customVideo.pause();
				document.querySelector("#custom_play_button .play_button_icon").style.display = "flex";
				document.querySelector("#custom_play_button .pause_button_icon").style.display = "none";

				// Update the button text to 'Play'
				//  playButton.innerHTML = "Play";
			}
		});
	}

	/* video play ends */
});
